import { createContext } from 'react';

const LocalStorageContext = createContext();

export const { Provider, Consumer } = LocalStorageContext;

export default LocalStorageContext;
